let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k9j9Q")).then(() => parcelRequire('8eXcv'));